import axios from "@/axios";

export default {
    rent(payload) {
        return axios.get(`bonuses/rent`, payload);
    },
    tariff(payload) {
        return axios.get(`bonuses/tariff`, payload);
    },
}
